let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("33bpP")).then(() => parcelRequire('7nn2C'));